module.exports = __webpack_public_path__ + "media/connectivity-slide2.1db0de7c.mp4";